import React, { useState } from 'react';
import ExplainTips from '../utils/ExplainTips';
import PropTypes from 'prop-types';

const propTypes = {
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onOpening: PropTypes.func,
  onClosing: PropTypes.func,
  onTriggerOpening: PropTypes.func,
  onTriggerClosing: PropTypes.func,
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tabIndex: PropTypes.number,
  explaintips: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

type CollapsibleProps = PropTypes.InferProps<typeof propTypes>;


const Collapsible = (props: CollapsibleProps) => {

  const [isClosed, setIsClosed] = useState(!props.open);
  const [visibility, setVisibility] = useState<'visible' | 'hidden' | 'collapse'>((props.open)?'visible':'hidden');
  const [inTransition, setInTransition] = useState(false);
  const [innerRef,setInnerRef] = useState(undefined);
  const [height,setHeight] = useState<number | string>(0);





  const triggerId = `collapsible-trigger-${Date.now()}`;
  const contentId = `collapsible-content-${Date.now()}`;
  const outerClassString = `Collapsible__contentOuter`;
  const innerClassString = `Collapsible__contentInner`;
  const openClass = isClosed ? 'is-closed' : 'is-open';
  const triggerClassString = `Collapsible__trigger ${openClass}`;

  const dropdownStyle: React.CSSProperties = {
    height: height,
    WebkitTransition: 'height 200ms linear',
    msTransition: 'height 200ms linear',
    transition: 'height 200ms linear',
    overflow: 'hidden',
    visibility:visibility,
  };

  console.log('visibility isClosed',props.trigger,visibility,isClosed,height,dropdownStyle);

  function setInnerReference (ref) {
    if(!innerRef && ref) {
      setHeight((props.open)?ref.scrollHeight:0);
    }
    setInnerRef(ref);
  }
  function handleTriggerClick (event) {
    if (inTransition) {
      return;
    }
    event.preventDefault();
    if (isClosed === true) {
      openCollapsible();
      props.onOpening();
      props.onTriggerOpening();
    } else {
      setHeight(innerRef.scrollHeight);
      //Small timeout to allow transition
      window.setTimeout(() => {
        closeCollapsible();
      },50);
      props.onClosing();
      props.onTriggerClosing();
    }
  };

  function openCollapsible() {
    setHeight(innerRef.scrollHeight);
    setVisibility('visible');
    setIsClosed(false);
    setInTransition(checkInTransition(innerRef.scrollHeight));
  }
  function closeCollapsible() {
    setHeight(0);
    setIsClosed(true);
    setInTransition(checkInTransition(innerRef.scrollHeight));
  }

  function handleTransitionEnd (e) {
    // only handle transitions that origin from the container of this component
    if (e.target !== innerRef) {
      return;
    }
    // Switch to height auto to make the container responsive
    if (!isClosed) {
      setHeight('auto');
      setInTransition(false);
      props.onOpen();
    } else {
      setInTransition(false);
      setVisibility('hidden');
      props.onClose();
    }
  };

  function  checkInTransition(innerRefScrollHeight) {
    return innerRefScrollHeight !== 0;
  }


	return (
    <div
      className="Collapsible"
    >
      <span
        id={triggerId}
        className={triggerClassString.trim()}
        onClick={handleTriggerClick}
        onKeyPress={(event) => {
          const { key } = event;
          if (
            key === 'Enter'
          ) {
            handleTriggerClick(event);
          }
        }}
        tabIndex={props.tabIndex && props.tabIndex}
        aria-expanded={!isClosed}
        aria-controls={contentId}
        role="button" // Since our default TriggerElement is not a button
      >
        {props.trigger}
        { props.explaintips && props.explaintips.length > 0 &&
          <ExplainTips text={props.explaintips} tipStyle={{top: '9px', left: '10px'}}></ExplainTips>
        }

      </span>

      <div
        id={contentId}
        className={outerClassString.trim()}
        style={dropdownStyle}
        onTransitionEnd={handleTransitionEnd}
        ref={setInnerReference}
        role="region"
        aria-labelledby={triggerId}
      >
        <div className={innerClassString.trim()}>{props.children}</div>
      </div>
    </div>
  );
}

Collapsible.defaultProps = {
  open: false,
  onOpen: () => {},
  onClose: () => {},
  onOpening: () => {},
  onClosing: () => {},
  onTriggerOpening: () => {},
  onTriggerClosing: () => {},
  trigger: null,
  tabIndex: null,
  explaintips: null,
};

export default Collapsible;